import { V2Product, V2ProductsMap, V2SKU } from "./schema"

/**
 * Get a single product by ID from the products map
 */
export function getProductById(
  productsMap: V2ProductsMap,
  productId: string
): V2Product | undefined {
  return productsMap[productId]
}

/**
 * Get multiple products by their IDs (filters out missing products)
 */
export function getProductsByIds(
  productsMap: V2ProductsMap,
  productIds: string[]
): V2Product[] {
  return productIds
    .map((id) => productsMap[id])
    .filter((p): p is V2Product => p !== undefined)
}

/**
 * Get a SKU by product ID and SKU ID
 */
export function getSKUById(
  productsMap: V2ProductsMap,
  productId: string,
  skuId: string
): V2SKU | undefined {
  const product = productsMap[productId]
  return product?.skus.find((s) => s.id === skuId)
}

/**
 * Get all products for a machine (from normalized data)
 */
export function getProductsForMachine(
  machineProductIds: string[],
  productsMap: V2ProductsMap
): V2Product[] {
  return getProductsByIds(productsMap, machineProductIds)
}

/**
 * Get SKUs for a specific product in a machine
 */
export function getSKUsForProduct(
  productsMap: V2ProductsMap,
  productId: string
): V2SKU[] {
  const product = productsMap[productId]
  return product?.skus || []
}
